import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncGetPaymentNum = createAsyncThunk(
    "/fetchAsyncGetPaymentNum",
    async (data) => {
      try {
        let url = `${API_URL}/payment-record/pyNo`;
        const response = await axiosInstance.get(url);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
);

export const fetchAsyncDeletePaymentRecord = createAsyncThunk(
  "/fetchAsyncDeletePaymentRecord",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/delete/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.delete( url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);
export const fetchAsyncDeleteTdsRecord = createAsyncThunk(
  "/fetchAsyncDeleteTdsRecord",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/delete-tds/${data.moduleId}/${data.id}`;
      const response = await axiosInstance.delete( url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncSearchGstRecords = createAsyncThunk(
  "/fetchAsyncSearchGstRecords",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/search-gst`;
      const params = new URLSearchParams();
      if (data.value) params.append('search', data.value);
      if (data.startDate) params.append('startDate', data.startDate);
      if (data.endDate) params.append('endDate', data.endDate);
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncSearchTdsRecords = createAsyncThunk(
  "/fetchAsyncSearchTdsRecords",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/search-tds`;
      const params = new URLSearchParams();
      if (data.value) params.append('search', data.value);
      if (data.startDate) params.append('startDate', data.startDate);
      if (data.endDate) params.append('endDate', data.endDate);
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncSearchPaymentRecords = createAsyncThunk(
  "/fetchAsyncSearchPaymentRecords",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/search-payment-records`;
      const params = new URLSearchParams();
      if (data.value) params.append('search', data.value);
      if (data.startDate) params.append('startDate', data.startDate);
      if (data.endDate) params.append('endDate', data.endDate);
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncInvoiceGstXlsxData = createAsyncThunk(
  "/fetchAsyncInvoiceGstXlsxData",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/gst-xlsx`;
      if (data?.role && data.startDate && data.endDate) {
        url = url + `?role=${data.role}&startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncInvoiceTdsXlsxData = createAsyncThunk(
  "/fetchAsyncInvoiceTdsXlsxData",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/tds-xlsx`;
      if (data?.role && data.startDate && data.endDate) {
        url = url + `?role=${data.role}&startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncInvoicePaymentXlsxData = createAsyncThunk(
  "/fetchAsyncInvoicePaymentXlsxData",
  async (data) => {
    try {
      let url = `${API_URL}/payment-record/payment-xlsx`;
      if (data?.role && data.startDate && data.endDate) {
        url = url + `?role=${data.role}&startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

const InvoiceGstRecordsSlice = createSlice({
  name: "gstRecords",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncSearchGstRecords.pending]: (state) => {},
    [fetchAsyncSearchGstRecords.fulfilled]: (state, { payload }) => {
      return payload;
    },
  },
});
const InvoiceTdsRecordsSlice = createSlice({
  name: "tdsRecords",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncSearchTdsRecords.pending]: (state) => {},
    [fetchAsyncSearchTdsRecords.fulfilled]: (state, { payload }) => {
      return payload;
    },
  },
});
const InvoicePaymentRecordsSlice = createSlice({
  name: "paymentRecords",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncSearchPaymentRecords.pending]: (state) => {},
    [fetchAsyncSearchPaymentRecords.fulfilled]: (state, { payload }) => {
      return payload;
    },
  },
});

export const getInvoiceGstRecords = (state) => state.gstRecords;
export const getInvoiceTdsRecords = (state) => state.tdsRecords;
export const getInvoicePaymentRecords = (state) => state.paymentRecords;

export const gstRecordsReducer = InvoiceGstRecordsSlice.reducer;
export const tdsRecordsReducer = InvoiceTdsRecordsSlice.reducer;
export const paymentRecordsReducer = InvoicePaymentRecordsSlice.reducer;